import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

import {isDefined} from '../../typecheck';

export const isCourseIndividual = (
  course?: Nullable<CourseApiModel>,
): boolean => isDefined(course?.client_id);
